import { Alert, Button, Card, Skeleton } from "antd";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/auth.slice";
import { fetchGroupFeeStats } from "../../../services/groupConsole.service";
import useGroupBranchSwitch from "../useGroupBranchSwitch";

const GroupFeeStats = () => {
  const user = useSelector(selectUser);
  const groupId = user?.group;
  const { goToBranch, switching } = useGroupBranchSwitch();
  const [pendingSchool, setPendingSchool] = useState(null);

  const feeStats = useQuery(
    ["group-console-fee-stats", groupId],
    () => fetchGroupFeeStats(groupId),
    { enabled: !!groupId },
  );

  const viewDashboard = (schoolId) => {
    setPendingSchool(schoolId);
    goToBranch(schoolId, "/dashboard/admin/menu/fee/dashboard");
  };

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className="bg-white drop-shadow-md p-8 w-full"
      >
        <div className="text-2xl text-orange-500 font-semibold pb-1">
          Fee Stats
        </div>
        <div className="text-sm text-gray-500 pb-4">
          Quick collection glance per branch. Open a branch for its full, proper
          fee analytics — the same dashboard that branch's own admin uses.
        </div>

        {!!feeStats.data?.errors?.length && (
          <Alert
            className="mb-4"
            type="warning"
            showIcon
            message={`Could not load ${feeStats.data.errors.length} branch${
              feeStats.data.errors.length > 1 ? "es" : ""
            }: ${feeStats.data.errors.map((e) => e.school_name).join(", ")}`}
          />
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {(feeStats.data?.branches || []).map((b) => (
            <Card
              key={b.school}
              size="small"
              title={
                <span
                  className="text-primary-600 cursor-pointer hover:underline"
                  onClick={() => viewDashboard(b.school)}
                >
                  {b.school_name}
                </span>
              }
            >
              <div className="text-xl font-semibold">
                ₹{(b.collected ?? 0).toLocaleString("en-IN")}
              </div>
              <div className="text-xs text-gray-500">
                collected
                {b.collectionRate != null ? ` · ${b.collectionRate}%` : ""}
              </div>
              <div className="text-xs text-orange-500 mt-2 mb-3">
                ₹{(b.remaining ?? 0).toLocaleString("en-IN")} remaining
              </div>
              <Button
                size="small"
                type="primary"
                loading={switching && pendingSchool === b.school}
                onClick={() => viewDashboard(b.school)}
              >
                View Full Analytics
              </Button>
            </Card>
          ))}
          {feeStats.isLoading &&
            Array.from({ length: 4 }).map((_, i) => (
              <Card key={i} size="small">
                <Skeleton active paragraph={{ rows: 2 }} />
              </Card>
            ))}
        </div>

        {feeStats.data?.totals && (
          <div className="mt-4 text-sm text-gray-600">
            Group total collected: ₹
            {(feeStats.data.totals.collected ?? 0).toLocaleString("en-IN")} ·
            remaining: ₹
            {(feeStats.data.totals.remaining ?? 0).toLocaleString("en-IN")}
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupFeeStats;
